import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject } from "vue";
import BaseInput from "@/components/shared/inputs/base/BaseInput.vue";
import { useUserStore } from "@/stores/userStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";


const __default__ = {
  name: "LoginIdInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  value: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
  successMessage: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Object,
  },
  certRequired: {
    type: Boolean,
    default: true,
  },
  required: {
    type: Boolean,
  },
},
  emits: ["update:value"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const emit = __emit;

const inputValue = computed({
  get(): string {
    return props.value as string;
  },
  set(inputValue: string) {
    resetCheckDuplicate();
    emit("update:value", inputValue);
  },
});

const getRules = computed(() => {
  return props.certRequired && !props.disabled
    ? { ...props.rules, checkDuplication: `${isCheckDuplicateSuccess.value}` }
    : props.rules;
});

const userStore = useUserStore();

const isLoading = ref(false);

const checkDuplicateSuccessMsg = ref("");
const checkDuplicateErrorMsg = ref("");
const isCheckDuplicateSuccess = ref(false);
const checkDuplicateId = async () => {
  isCheckDuplicateSuccess.value = true;
  isLoading.value = true;
  const checkDuplicateResult = await userStore.checkDuplicateId(
    inputValue.value
  );
  isLoading.value = false;

  if (checkDuplicateResult.isSuccess) {
    checkDuplicateSuccessMsg.value = "사용 가능한 아이디입니다.";
    return;
  }

  isCheckDuplicateSuccess.value = false;

  if (checkDuplicateResult.resultCode === 409000004) {
    checkDuplicateErrorMsg.value = "이미 가입된 아이디입니다.";
    return;
  }

  showErrorModal(
    "아이디 중복 확인 오류",
    checkDuplicateResult.errorMessage,
    checkDuplicateResult.resultCode,
    checkDuplicateResult.errorTime
  );
};

const resetCheckDuplicate = () => {
  checkDuplicateSuccessMsg.value = "";
  checkDuplicateErrorMsg.value = "";
  isCheckDuplicateSuccess.value = false;
};

const __returned__ = { props, showErrorModal, emit, inputValue, getRules, userStore, isLoading, checkDuplicateSuccessMsg, checkDuplicateErrorMsg, isCheckDuplicateSuccess, checkDuplicateId, resetCheckDuplicate, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})